import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import actionTimer from 'app/components/actiontimer';
import { ActionService } from '../../../services/action.service';
import { taskTypeActionFeatures } from './TaskTypeActionFeatures';
import Utils from '../../../shared/utils';
import { CustomerTouchService } from '../../../services/customer-touch.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TaskService } from '../../../services/task.service';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError, filter, finalize, map, switchMap, tap } from 'rxjs/operators';
import { SessionStorageService } from '../../../services/session-storage.service';
import RejectionFactory from '../../../factories/RejectionFactory';
import { ErrorMessages } from 'app/models/ErrorMessages';
import TaskStatuses = Boo.Objects.Enums.TaskStatusEnum;
import TaskTypes = Boo.Objects.Enums.TaskTypeEnum;

type OutputWithRejectionReason = Boo.Tasks.Outputs.Models.OutputWithRejectionReason;

@Component({
  selector: 'app-components-specialist-actionworkspace',
  templateUrl: './ActionWorkspace.component.html'
})
export class ActionWorkspaceComponent implements OnInit {
  utils = Utils;
  dfd: any;
  skipReason: any;
  actionTimer: any;
  viewModelUpdateTimer: any;
  // Observables
  isReadOnly: any = ko.observable(false);
  title: string;
  currentAction: any = ko.observable();
  isLoading: any = ko.observable(false);
  CustomerUrl: any = ko.observable();
  readyToComplete: any = ko.observable(false);
  customerId: any = ko.observable();
  activeChild: any = ko.observable();
  taskTime: any = ko.observable(0);
  canDelete: any = ko.observable(true);
  canWorkblock = false;
  showCustomerCountry = false;
  showPartnerName = false;
  showCustomerName = false;
  workblockReason: UntypedFormControl = new UntypedFormControl(null);
  workblockNote: UntypedFormControl = new UntypedFormControl('');
  currentUser: Boo.Objects.User;

  private implementationCustomTaskTypes = [
    Boo.Objects.Enums.TaskTypeEnum.ThreeHundredOneRedirectMappingAndImplementation,
    Boo.Objects.Enums.TaskTypeEnum.GoogleAnalyticsCreationAndImplementation,
    Boo.Objects.Enums.TaskTypeEnum.BlogMatching,
    Boo.Objects.Enums.TaskTypeEnum.CanonicalDomainImplementation,
    Boo.Objects.Enums.TaskTypeEnum.CanonicalTagImplementation,
    Boo.Objects.Enums.TaskTypeEnum.ClickTrackingImplementation,
    Boo.Objects.Enums.TaskTypeEnum.DomainTransfer,
    Boo.Objects.Enums.TaskTypeEnum.GoogleMapsIntegration,
    Boo.Objects.Enums.TaskTypeEnum.GoogleSearchConsoleCreationAndInstallation,
    Boo.Objects.Enums.TaskTypeEnum.InsertNofollowTagsIntoOnsiteLinks,
    Boo.Objects.Enums.TaskTypeEnum.LoginCredentialTesting,
    Boo.Objects.Enums.TaskTypeEnum.MenuEdits,
    Boo.Objects.Enums.TaskTypeEnum.OnsiteBlogInstallationStandardCMS,
    Boo.Objects.Enums.TaskTypeEnum.OnsiteBrokenLinkRepair,
    Boo.Objects.Enums.TaskTypeEnum.OnsiteCopyImplementationManual,
    Boo.Objects.Enums.TaskTypeEnum.OnsiteRecommendationImplementationManual,
    Boo.Objects.Enums.TaskTypeEnum.WebPageCreation,
    Boo.Objects.Enums.TaskTypeEnum.WebPageDeletion,
    Boo.Objects.Enums.TaskTypeEnum.RemoveExcessH1Tags,
    Boo.Objects.Enums.TaskTypeEnum.RobotsTxtCreation,
    Boo.Objects.Enums.TaskTypeEnum.RobotsTxtFileCreationAndImplementation,
    Boo.Objects.Enums.TaskTypeEnum.SchemaTagImplementation,
    Boo.Objects.Enums.TaskTypeEnum.SiteSpeedOptimization,
    Boo.Objects.Enums.TaskTypeEnum.SitemapXmlCreation,
    Boo.Objects.Enums.TaskTypeEnum.XMLSitemapCreationAndImplementation,
    Boo.Objects.Enums.TaskTypeEnum.VideoImageImplementation,
    Boo.Objects.Enums.TaskTypeEnum.PageCreationImplementation,
    Boo.Objects.Enums.TaskTypeEnum.PageOptimizationImplementation
  ];

  rejectionCtrl: UntypedFormGroup = new UntypedFormGroup({
    rejectionReason: new UntypedFormControl('', [Validators.required, Validators.maxLength(4000)])
  });

  actionIsLoaded: any = ko.computed(() => {
    return (_.isObject(this.activeChild()) &&
      ko.isObservable(this.activeChild().currentAction) &&
      _.isObject(this.activeChild().currentAction()) &&
      _.isObject(this.activeChild().currentAction().Task) &&
      _.isObject(this.activeChild().currentAction().Task.TaskTypeSummary) &&
      _.isObject(this.activeChild().currentAction().TaskDetails) &&
      _.isObject(this.activeChild().currentAction().TaskDetails.WebsiteUrl) &&
      $.trim(this.activeChild().currentAction().Task.TaskTypeSummary.ControlName) !== '');
  });

  canTaskTypeSkip: any = ko.computed(() => {
    let result = true;
    if (this.actionIsLoaded() &&
      this.activeChild().currentAction() &&
      this.activeChild().currentAction().Task &&
      this.activeChild().currentAction().Task.TaskTypeSummary) {
      result = this.activeChild().currentAction().Task.TaskTypeSummary.IsSkippable;
    }
    return result;
  });

  canReject: any = ko.computed(() => {
    let result = false;
    if (this.actionIsLoaded() && this.activeChild().currentAction()) {
      const taskTypeId = this.actionIsLoaded() && this.activeChild().currentAction().Task.TaskTypeEnum;
      result = _.contains(taskTypeActionFeatures.rejectable, taskTypeId);
    }
    return result;
  });

  canRejectWithoutProvidingReason: any = ko.computed(() => {
    let result = false;
    if (this.actionIsLoaded() && this.activeChild().currentAction()) {
      const taskTypeId = this.actionIsLoaded() && this.activeChild().currentAction().Task.TaskTypeEnum;
      result = _.contains(taskTypeActionFeatures.rejectableWithoutReason, taskTypeId);
    }
    return result;
  });

  usesRejectionObject = false;

  showTimer: any = ko.computed(() => {
    let show = false;
    if (this.actionIsLoaded()) {
      show = _.contains(taskTypeActionFeatures.hasTimer, this.activeChild().currentAction().Task.TaskTypeEnum);
    }
    return show;
  });

  canUnlockAndUnassign: any = ko.computed(() => {
    let result = false;
    if (this.actionIsLoaded() && this.activeChild().currentAction()) {
      // Persistable tasks can never be unlocked and unassigned and are handled separately from this array
      const taskTypeIdsThatCanNotUnlockAndUnassign = _.union(taskTypeActionFeatures.canNotUnlockAndUnassign, this.implementationCustomTaskTypes);
      const taskTypeId = this.actionIsLoaded() && this.activeChild().currentAction().Task.TaskTypeEnum;
      result = _.contains(taskTypeIdsThatCanNotUnlockAndUnassign, taskTypeId) === false;
    }
    return result;
  });

  isPersistable: any = ko.computed(() => {
    return this.actionIsLoaded() && this.activeChild().currentAction().Task.TaskTypeSummary.IsPersistable;
  });

  actionName: any = ko.computed(() => {
    return this.actionIsLoaded() && this.activeChild().currentAction().Task.TaskTypeSummary.Name;
  });

  actionTaskDate: any = ko.computed(() => {
    let result = '';
    if (this.actionIsLoaded()) {
      result = moment(this.activeChild().currentAction().Task.TaskDate).format('MM/DD/YYYY');
    }
    return result;
  });

  estimatedTime: any = ko.computed(() => {
    let result = '';
    if (this.actionIsLoaded() === true) {
      result = this.activeChild().currentAction().Task.TaskTypeSummary.EstimatedMinutes + ' Minutes';
    }
    return result;
  });

  customerUrl: any = ko.computed(() => {
    let customerUrl = '';
    if (this.actionIsLoaded()) {
      customerUrl = this.activeChild().currentAction().TaskDetails.WebsiteUrl.Url;
    }
    return customerUrl;
  });

  customerName: any = ko.computed(() => {
    let customerName = '';
    if (this.actionIsLoaded() && this.activeChild().currentAction().Customer) {
      customerName = this.activeChild().currentAction().Customer.Name;
    } else if (this.activeChild()?.currentAction()?.Task?.Input?.Customer) {
      customerName = this.activeChild().currentAction().Task.Input.Customer.Name;
    }
    return customerName;
  });

  customerLanguage: any = ko.computed(() => {
    let customerLanguage = 'N/A';
    if (this.actionIsLoaded() && this.activeChild().currentAction().Customer && this.activeChild().currentAction().Customer.Language) {
      customerLanguage = this.activeChild().currentAction().Customer.Language.Name;
    } else if (this.activeChild()?.currentAction()?.Task?.Input?.Customer) {
      customerLanguage = this.activeChild().currentAction().Task.Input.Customer.Language.Name;
    }
    return customerLanguage;
  });

  customerCountry: any = ko.computed(() => {
    let customerCountry = 'N/A';
    if (this.actionIsLoaded() && this.activeChild().currentAction().Customer && this.activeChild().currentAction().Customer.Country) {
      customerCountry = this.activeChild().currentAction().Customer.Country.Name;
    } else if (this.activeChild()?.currentAction()?.Task?.Input?.Customer) {
      customerCountry = this.activeChild().currentAction().Task.Input.Customer.Country.Name;
    }
    return customerCountry;
  });

  customerVertical: any = ko.computed(() => {
    let customerVertical = 'N/A';
    if (this.actionIsLoaded() && this.activeChild().currentAction().Customer && this.activeChild().currentAction().Customer.Vertical) {
      customerVertical = this.activeChild().currentAction().Customer.Vertical.Name;
    } else if (this.activeChild()?.currentAction()?.Task?.Input?.Customer) {
      customerVertical = this.activeChild().currentAction().Task.Input.Customer.Vertical.Name;
    }
    return customerVertical;
  });

  constructor(
    private modalService: NgbModal,
    private actionService: ActionService,
    private taskService: TaskService,
    private customerTouchService: CustomerTouchService,
    private sessionStorageService: SessionStorageService) { }

    
  ngOnInit(): void {
    this.sessionStorageService.getUser()
      .subscribe((user) => this.currentUser = user);
  }

  activate(options: ActionWorkspacePriorityViewParams): void {
    this.actionTimer = new actionTimer(() => this.close(false));
    this.taskTime(this.actionTimer.getFormattedSeconds());
    if (options.isReadOnly) {
      this.isReadOnly(options.isReadOnly);
    }

    const action = options.currentAction;
    if (action && action.Task) {
      const taskTypeName = action?.Task?.TaskTypeSummary?.Name;

      if (taskTypeName) {
        const partnerName = action?.Customer?.Partner?.Name ?? (action?.Task?.Input as any)?.Customer?.Partner?.Name ?? '';
        const trimmedPartnerName = partnerName.trim();

        this.title = trimmedPartnerName ? `${trimmedPartnerName} - ${taskTypeName}` : taskTypeName;
      }

      //Inputs are used for history and should never be altered by a workspace
      if (action.Task.Input)
      {
        Utils.deepFreeze(action.Task.Input);
      }

      this.currentAction(action);
      this.loadWorkspace(action);
      this.canDelete(_.contains(taskTypeActionFeatures.deletable, action.Task.TaskTypeEnum));
      this.canWorkblock = _.contains(taskTypeActionFeatures.workblockable, action.Task.TaskTypeEnum);
      this.showCustomerCountry = _.contains(taskTypeActionFeatures.showCustomerCountry, this.activeChild().currentAction().Task.TaskTypeEnum);
      this.showPartnerName = _.contains(taskTypeActionFeatures.showPartnerName, this.activeChild().currentAction().Task.TaskTypeEnum);
      this.showCustomerName = _.contains(taskTypeActionFeatures.showCustomerName, this.activeChild().currentAction().Task.TaskTypeEnum);
      this.usesRejectionObject = _.contains(taskTypeActionFeatures.usesRejectionObject, this.activeChild().currentAction().Task.TaskTypeEnum);
    } else {
      toastr.error('Failed to load next action. Please refresh your browser and try again. If this issue persists please contact your manager');
      this.close(false);
    }
  }

  deactivate(): void {
    this.actionTimer.stop();
    clearInterval(this.viewModelUpdateTimer);
  }

  updateViewModel(): void {
    this.taskTime(this.actionTimer.getFormattedSeconds());
  }

  rejectTask(modal: NgbModalRef = null): void {
    this.isLoading(true);
  
    this.ensureCanTakeAction()
      .pipe(
        switchMap(canTakeAction => {
          if (!canTakeAction) {
            return EMPTY;
          }
    
          if (!this.activeChild().actionViewModel().isStepReadyToReject()) {
            toastr.error(ErrorMessages.ValidationFailed);
            return EMPTY;
          }
    
          if (this.canRejectWithoutProvidingReason()) {
            return this.confirmReject$()
            .pipe(
              filter(result => result === true),
              switchMap(() => this.reject())
            );
          }
    
          this.applyRejectionReason();
          return this.reject();
        }),
        finalize(() => {
          this.isLoading(false);
          modal?.dismiss();
        })
      ).subscribe({
        error: err => toastr.error(err)
      });
  }

  saveTask(modal: NgbModalRef = null): void {
    this.isLoading(true);
  
    const workspace = this.getActiveWorkspace();
    if (!workspace) {
      this.isLoading(false);
      return;
    }
  
    this.ensureCanTakeAction()
      .pipe(
        switchMap(canTakeAction => {
          if (!canTakeAction) {
            return EMPTY;
          }
    
          if (!workspace.isStepReadyToSave()) {
            toastr.error(ErrorMessages.ValidationFailed);
            return EMPTY;
          }

          return this.save();
        }),
        finalize(() => {
          this.isLoading(false);
          modal?.dismiss();
        })
      ).subscribe({
        error: err => toastr.error(err)
      });
  }

  completeTask(modal: NgbModalRef = null): void {
    this.isLoading(true);
  
    const workspace = this.getActiveWorkspace();
    if (!workspace) {
      this.isLoading(false);
      return;
    }
  
    this.ensureCanTakeAction()
      .pipe(
        switchMap(canTakeAction => {
          if (!canTakeAction) {
            return EMPTY;
          }
    
          if (!workspace.isStepReadyToComplete()) {
            toastr.error(ErrorMessages.ValidationFailed);
            return EMPTY;
          }

          return this.complete();
        }),
        finalize(() => {
          this.isLoading(false);
          modal?.dismiss();
        })
      ).subscribe({
        error: err => toastr.error(err)
      });
  }

  deleteTask(modal: NgbModalRef = null): void {
    this.isLoading(true);
  
    const workspace = this.getActiveWorkspace();
    if (!workspace) {
      this.isLoading(false);
      return;
    }
  
    this.ensureCanTakeAction()
      .pipe(
        switchMap(canTakeAction => {
          if (!canTakeAction) {
            return EMPTY;
          }
    
          if (!workspace.isStepReadyToDelete()) {
            toastr.error(ErrorMessages.ValidationFailed);
            return EMPTY;
          }
    
          return this.delete();
        }),
        finalize(() => {
          this.isLoading(false);
          modal?.dismiss();
        })
      ).subscribe({
        error: err => toastr.error(err)
      });
  }

  cancelTask(showNotification = true): void {
    this.isLoading(true);
  
    if (!this.actionIsLoaded()) {
      this.isLoading(false);
      return;
    }
  
    this.quitView$()
      .pipe(
        switchMap(shouldQuit => shouldQuit ? EMPTY : this.ensureCanTakeAction(false)),
        switchMap(canTakeAction => {
          if (!canTakeAction) {
            return EMPTY;
          }
    
          const task = this.activeChild().currentAction().Task;
    
          return this.taskService
            .unassignAndUnlockNonPersistableAssignedTask(task.TaskId, task.AssignedUserId)
            .pipe(
              tap(() => {
                if (showNotification) {
                  toastr.success('Tasks have been unlocked and unassigned.');
                }
                this.activeChild(undefined);
              }),
              catchError(err => {
                toastr.error(err);
                return EMPTY;
              })
            );
        }),
        finalize(() => {
          this.isLoading(false);
          if (this.dfd) {
            this.dfd.resolve();
          }
        })
      ).subscribe();
  }

  close(shouldReload: any): void {
    if (this.dfd) {
      this.dfd.resolve(shouldReload);
    }
  }

  closeTask(): void {
    this.close(false);
  }

  openModal(template: any, action: string): void {
    this.ensureCanTakeAction()
      .pipe(
        finalize(() => this.isLoading(false))
      )
      .subscribe({
        next: canTakeAction => {
          if (canTakeAction) {
            this.modalService.open(template);
          }
        },
        error: (err) => toastr.error(err)
      });
  }

  customerSkipSaved(modal: NgbModalRef): void {
    if (this.activeChild().actionViewModel() && this.activeChild().actionViewModel().onSkip) {
        this.activeChild().actionViewModel().onSkip();
    }

    modal.dismiss();
    this.close(false);
  }

  workblockSaved(modal: NgbModalRef): void {
    Utils.wrapDfd(this.customerTouchService.insert(this.customerId(), this.actionTimer.getElapsedSeconds(), 'Create Action Workblock Ticket'))
      .then(() => {
        modal.dismiss();
        $('#content').slideUp(
          500,
          () => {
            this.isLoading(false);
            toastr.success('Successfully updated.');
            this.close(true);
          });
      });
  }

  private loadWorkspace(currentAction: Boo.Objects.Action): void {
    this.activeChild(
      {
        selector: `app-components-specialist-actioncomponents-${currentAction.Task.TaskTypeSummary.ControlName}`,
        actionViewModel: ko.observable(),
        currentAction: ko.observable(currentAction),
        output: currentAction.Task.Output,
        input: currentAction.Task.Input ? structuredClone(currentAction.Task.Input) : null
      });
    this.actionTimer.start();
    // Update timer view every second
    this.viewModelUpdateTimer = setInterval(() => this.updateViewModel(), 1000);
    // CustomerId must be set for the skipCustomerModal
    this.customerId(this.actionIsLoaded() ? this.activeChild().currentAction().Task.CustomerId : '');
    $('#content').animateCSS('fadeInDown');
  }

  private saveTaskDuration(): void {
    // Logic to prevent overwriting of the minutes on a previously completed action
    if (this.actionIsLoaded() && this.activeChild().currentAction().Task.TaskStatusEnum !== TaskStatuses.Complete) {
      let seconds: number;
  
      // Save actual time for Onsite Content Change and Onsite Recommendation tasks
      if (this.activeChild().currentAction().Task.TaskTypeSummary.TaskTypeId === TaskTypes.OnsiteRecommendationCreateContent) {
        seconds = this.activeChild().actionViewModel().timer.elapsedSeconds;
      } else {
        seconds = this.actionTimer.getElapsedSeconds();
      }
  
      // Launchpad completed tasks will always save with at least 1 second.
      seconds = seconds === 0 ? 1 : seconds;
  
      this.activeChild().currentAction().Task.ActualSeconds += seconds;
    }
  }

  private takeAction(newActionStatus: TaskStatuses, preventReload: boolean): Observable<void> {
    if (newActionStatus === TaskStatuses.Complete || newActionStatus === TaskStatuses.Deleted || newActionStatus === TaskStatuses.SaveProgress) {
      this.saveTaskDuration();
    }
  
    this.activeChild().currentAction().Task.TaskStatusEnum = newActionStatus;
    const currentAction = this.activeChild().currentAction();
  
    return this.persistAction(currentAction, preventReload);
  }

  private persistAction(currentAction: Boo.Objects.Action, preventReload: boolean): Observable<void> {
    return this.quitView$()
    .pipe(
      switchMap(shouldQuit => {
        if (shouldQuit) {
          return EMPTY;
        }
  
        this.isLoading(true);
  
        return this.actionService.updateStatus(currentAction)
          .pipe(
            tap(() => {
              $('#content').slideUp(500, () => {
                toastr.success('Successfully updated.');
                this.close(!preventReload);
              });
            }),
            map(() => void 0),
            catchError(err => {
              toastr.error(err);
              this.isLoading(false);
              return throwError(() => err);
            }),
            finalize(() => this.isLoading(false))
          );
      })
    );
  }

  private quitView$(): Observable<boolean> {
    if (!this.isReadOnly()) {
      return of(false);
    }
  
    this.isLoading(false);
    this.dfd?.resolve();
  
    return of(true);
  }

  private ensureCanTakeAction(showMessage = true): Observable<boolean> {
    const taskId = this.activeChild().currentAction().Task.TaskId;
  
    return this.taskService.isActionableByUser(taskId, this.currentUser.UserId)
      .pipe(
        switchMap(canTakeAction => {
          if (canTakeAction) {
            return of(true);
          }
    
          if (showMessage) {
            return new Observable<boolean>(observer => {
              bootbox.dialog({
                message: `This task (${taskId}) has been unassigned from your user or is no longer available. Please get your next task.`,
                closeButton: false,
                buttons: {
                  ok: {
                    label: 'OK',
                    className: 'btn-primary',
                    callback: () => {
                      this.close(false);
                      observer.next(false);
                      observer.complete();
                    }
                  }
                }
              });
            });
          } else {
            this.close(false);
            return of(false);
          }
        })
      );
  }

  private getRejectionTaskStatus(): Boo.Objects.Enums.TaskStatusEnum {
    // Sometimes when we reject a task, we want to delete it instead of setting it to NeedsData
    if (taskTypeActionFeatures.rejectUsingDelete.includes(this.activeChild().currentAction().Task.TaskTypeSummary.TaskTypeId)) {
      return Boo.Objects.Enums.TaskStatusEnum.Deleted;
    }
    return Boo.Objects.Enums.TaskStatusEnum.NeedsData;
  }

  private isOutputWithRejectionReason(obj: any): obj is OutputWithRejectionReason {
    return 'RejectionReason' in obj;
  }

  private confirmReject$(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      bootbox.confirm(
        'This will reject the current task. Are you sure you want to do this?',
        result => {
          observer.next(result);
          observer.complete();
        }
      );
    });
  }

  private applyRejectionReason(): void {
    const action = this.activeChild().currentAction();

    if (this.usesRejectionObject) {
      action.TaskDetails.Rejection = RejectionFactory.createRejectionFromReasons(this.currentUser.UserId, [], this.rejectionCtrl.get('rejectionReason').value);
    } else if (this.isOutputWithRejectionReason(action.Task.Output)) {
      action.Task.Output.RejectionReason = this.rejectionCtrl.get('rejectionReason').value;
    } else {
      action.TaskDetails.Reason = this.rejectionCtrl.get('rejectionReason').value;
    }
  }

  private getActiveWorkspace(): IActionWorkspace | null {
    if (!_.isObject(this.activeChild())) {
      toastr.error('Could not complete task. ActiveChild is undefined. Please notify your manager of this error.');
      return null;
    }
    const vm = ko.isObservable(this.activeChild().actionViewModel) ? this.activeChild().actionViewModel() : null;
    if (!_.isObject(vm)) {
      toastr.error('Could not complete task. ActionViewModel is undefined. Please notify your manager of this error.');
      return null;
    }
    return vm as IActionWorkspace;
  }

  private isPersistableActionWorkspace(workspace: IActionWorkspace): workspace is IPersistableActionWorkspace {
    return (
      'save' in workspace &&
      'complete' in workspace &&
      'delete' in workspace &&
      'reject' in workspace
    );
  }

  private reject(): Observable<void> {
    const workspace = this.activeChild().actionViewModel();
    const rejectionTaskStatus = this.getRejectionTaskStatus();
    const preventReload = false;
  
    return this.quitView$()
      .pipe(
        switchMap(shouldQuit => {
          if (shouldQuit) {
            return EMPTY;
          }
    
          const reject$: Observable<void> = this.isPersistableActionWorkspace(workspace)
            ? workspace.reject()
            : of(void 0);
    
          return reject$
            .pipe(
              switchMap(() =>
                this.takeAction(rejectionTaskStatus, preventReload)
              )
            );
        })
      );
  }

  private save(): Observable<void> {
    const workspace = this.activeChild().actionViewModel();
    const saveTaskStatus = TaskStatuses.SaveProgress;
    const preventReload = true;
  
    return this.quitView$()
      .pipe(
        switchMap(shouldQuit => {
          if (shouldQuit) {
            return EMPTY;
          }
    
          const save$: Observable<void> = this.isPersistableActionWorkspace(workspace)
            ? workspace.save()
            : of(void 0);
    
          return save$
            .pipe(
              switchMap(() =>
                this.takeAction(saveTaskStatus, preventReload)
              )
            );
        })
      );
  }

  private complete(): Observable<void> {
    const workspace = this.activeChild().actionViewModel();
    const saveTaskStatus = TaskStatuses.Complete;
    const preventReload = false;
  
    return this.quitView$()
      .pipe(
        switchMap(shouldQuit => {
          if (shouldQuit) {
            return EMPTY;
          }
    
          const complete$: Observable<void> = this.isPersistableActionWorkspace(workspace)
            ? workspace.complete()
            : of(void 0);
    
          return complete$
            .pipe(
              switchMap(() =>
                this.takeAction(saveTaskStatus, preventReload)
              )
            );
        })
      );
  }

  private delete(): Observable<void> {
    const workspace = this.activeChild().actionViewModel();
    const saveTaskStatus = TaskStatuses.Deleted;
    const preventReload = false;
  
    return this.quitView$()
      .pipe(
        switchMap(shouldQuit => {
          if (shouldQuit) {
            return EMPTY;
          }
    
          const delete$: Observable<void> = this.isPersistableActionWorkspace(workspace)
            ? workspace.delete()
            : of(void 0);
    
          return delete$
            .pipe(
              switchMap(() =>
                this.takeAction(saveTaskStatus, preventReload)
              )
            );
        })
      );
  }
}
